module.exports = __webpack_public_path__ + "img/portrait-sian.27da4ead.jpg";